import { render, staticRenderFns } from "./CreatePriceList.vue?vue&type=template&id=096263df&"
import script from "./CreatePriceList.vue?vue&type=script&lang=js&"
export * from "./CreatePriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports